import React from 'react';
import { useNavigate } from 'react-router-dom';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import { routes } from '../../../routing';
import { ITicketSelector } from '../../../store/selectors/tickets';

import HistoryPanel from '../../../components/Panels/HistoryPanel';
import Badge from '../../../components/Feedback/Badge';

interface Props {
  tickets: ITicketSelector[];
}

const TicketHistoryCards = ({ tickets }: Props) => {
  const navigate = useNavigate();

  return (
    <List gap="16" className="indent-md-top">
      {tickets.map((ticket) => {
        return (
          <HistoryPanel
            key={ticket.id}
            date={ticket.createdAt}
            withNoticeDot={!!ticket.unread}
            title={String(ticket.id)}
            description={ticket.subject || ''}
            onClick={() => navigate(`${routes.tickets}/${ticket.id}`)}
          >
            <Badge color={ticket.status.color}>{ticket.status.children}</Badge>
          </HistoryPanel>
        );
      })}
    </List>
  );
};

export default TicketHistoryCards;
